import {
  cleanSignalsAction,
  sendSignalsAction,
  toggleSignalsAction,
} from './reducers';

export { cleanSignalsAction, sendSignalsAction, toggleSignalsAction };

export const ADD_SIGNALS = sendSignalsAction.type;
export const CLEAN_SIGNALS = cleanSignalsAction.type;
export const TOGGLE_SIGNALS = toggleSignalsAction.type;
